import { useRouter } from 'next/router';
import useWindowSize from '@hooks/use-window-size';
import { useBucket } from '@context/bucket.context';
import {
  isFromStickyNav,
  isStickyNavEligibleByPage,
  isStickyNavVariant,
} from '@helpers/utils/sticky-nav/sticky-nav-utils';
import { isHomePage } from '@helpers/routing';
import StickyNavEntryPoint from './sticky-nav-entry-point';

type StickyNavEntryPointWrapperProps = {
  stickyNavTestGroup?: string;
  isVestiaireReferrer?: boolean;
  universe?: number;
};

const StickyNavEntryPointWrapper: React.FC<StickyNavEntryPointWrapperProps> = ({
  stickyNavTestGroup,
  isVestiaireReferrer = false,
  universe,
}) => {
  const router = useRouter();
  const { pathname, asPath, query } = router;
  const { isFeatureEnabled } = useBucket();
  const { isWiderThanMd } = useWindowSize();

  const isEligible = isStickyNavEligibleByPage({
    isMobile: !isWiderThanMd,
    pathname,
    asPath,
    hasFromStickyNav: isFromStickyNav(query),
    isVestiaireReferrer,
  });

  if (!isEligible) {
    return null;
  }

  if (isHomePage(pathname, asPath) && !isStickyNavVariant(stickyNavTestGroup)) {
    return null;
  }
  if (!isFeatureEnabled((f) => f.enableMultiCatStickyEntrypointNav, true)) {
    return null;
  }
  return <StickyNavEntryPoint universe={universe} />;
};

export default StickyNavEntryPointWrapper;
